var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcono1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 160,
    viewBox: "0 0 159 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.625 159.965C38.3113 159.965 35.625 157.279 35.625 153.965L35.625 20.5837L10.2629 46.1894C7.93095 48.5437 4.132 48.5619 1.77768 46.23C-0.576636 43.898 -0.594786 40.0991 1.73714 37.7448L37.3621 1.77768C38.489 0.640045 40.0238 -1.39989e-07 41.625 0C43.2262 1.39989e-07 44.761 0.640045 45.8879 1.77768L81.5129 37.7448C83.8448 40.0991 83.8266 43.8981 81.4723 46.23C79.118 48.5619 75.3191 48.5437 72.9871 46.1894L47.625 20.5837L47.625 153.965C47.625 157.279 44.9387 159.965 41.625 159.965ZM107.193 70.0001H96.0112L121.136 0.181888H133.307L158.432 70.0001H147.25L140.867 51.5228H113.587L107.193 70.0001ZM127.511 12.8637L137.805 42.6592H116.655L126.966 12.8637H127.511ZM102.488 152.977V160H152.398V150.932H115.375L152.091 97.2046V90.1819H102.182V99.2501H139.204L102.488 152.977Z",
    fill: "#3880E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono1);
export default __webpack_public_path__ + "static/media/Icono1.0a642eaa45921b18e1a59001f60dab4c.svg";
export { ForwardRef as ReactComponent };